import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PM_Duration_Interface } from 'src/app/Interface/PM_Duration_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PM_DurationService {

  constructor(private http: HttpClient) { }

  GetRecord(Token: String): Observable<Array<PM_Duration_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMDuration?token=" + Token).pipe(
      map(data => {
        return data as Array<PM_Duration_Interface>
      })
    )
  }

  GetActive(Token: String): Observable<Array<PM_Duration_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/PMDuration/GetActiveList?token=" + Token).pipe(
      map(data => {
        return data as Array<PM_Duration_Interface>
      })
    )
  }

  AddEditPM(
    model: PM_Duration_Interface,
    Token: String): Observable<PM_Duration_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');



    var body = {
      id: model.id,
      title: model.title,
      duration: model.duration,
      username: Token
    }

    return this.http.post(environment.BaseUrl + "Daro/PMDuration/AddEdit", body, { headers }).pipe(
      map(data => {
        return data as PM_Duration_Interface
      })
    )

  }




  DeletePM(id: number, Token: String): Observable<PM_Duration_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/PMDuration/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as PM_Duration_Interface
      })
    )

  }


}
